var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "kee" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("svg-icon", {
          staticClass: "mr-5",
          attrs: { "icon-name": "icon-kee-title", size: 16 },
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("clientDashboard.KEE")))]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "__content" },
      [
        _vm._l(_vm.menu, function (item, index) {
          return [
            _c(
              "div",
              {
                staticClass: "wl-client-item",
                class: "item" + (index + 1),
                on: {
                  click: function ($event) {
                    return _vm.clickCourseList(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "img-box" }, [
                  _c("img", { attrs: { src: item.src } }),
                ]),
                _c(
                  "div",
                  { staticClass: "info" },
                  [
                    _vm.newTag[item.newTag]
                      ? _c("div", {
                          class: [
                            "iconNew",
                            _vm.$i18n.locale === "en" ? "__en" : "",
                          ],
                        })
                      : _vm._e(),
                    _c(
                      "p",
                      {
                        class: [
                          _vm.$i18n.locale === "en"
                            ? "en-fontSize name"
                            : " name",
                        ],
                        style: "color: " + _vm.getFontColor(index),
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(item.name)) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: { content: _vm.$t(item.desc), placement: "top" },
                      },
                      [
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(_vm._s(_vm.$t(item.desc))),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }